import { useQuery } from '@tanstack/react-query';
import { getCategories } from '../api';
import { Category } from '../types/category';

export function useCategories() {
  const { 
    data: categories = [], 
    isLoading,
    error,
    refetch: refreshCategories
  } = useQuery<Category[]>({
    queryKey: ['categories'],
    queryFn: getCategories,
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
  });

  return {
    categories,
    loading: isLoading,
    error,
    refreshCategories
  };
}
